import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, InputAdornment, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import OrderListTable from "../components/order/OrderListTable";
import CancelConfirmationModal from "../components/modals/CancelConfirmationModal";

export default function HomePage() {

  const navigate = useNavigate();
  const { user, paymentlist } = useSelector(({ cognitouserReducer }) => cognitouserReducer);

  const [search, setSearch] = useState("");
  const [isCancelConfirmationModalOpen, setIsCancelConfirmationModalOpen] = useState(false);
  const { draft } = useSelector(({ orderReducer }) => orderReducer);

  const ClickNewOrder = async () => {
    const verifiedPayment = paymentlist.filter((p: any) => p.verified === "yes" && p.paymentId === user.primarypayment);
    if (verifiedPayment.length === 0) {
      setIsCancelConfirmationModalOpen(true);
    } else {
      if(draft){
        navigate("/order/save");
      }else{
        navigate("/order/search");
      }
    }
  };

  const GoToPaymentCardPage = async () => {
    navigate("/user/paymentcard");
  };

  const ClickUpdateOrder = (record: any) => {
    navigate("/order/save", { state: { updateRecord: record } });
  };

  const ClickEditAccount = () => {
    navigate("/user/profile/edit");
  };

  return (
    <div className="flex flex-col items-center w-full">
      <main className="container flex flex-col w-full py-12">
        {
          user && (
            <div className="flex justify-between w-full px-4 pb-6">
              <TextField
                variant="outlined"
                className="w-80"
                placeholder="Search items..."
                value={search}
                onChange={({ target: { value } }) => setSearch(value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
              <div className="flex gap-4 flex-col">
                <Button
                  variant="contained"
                  className="px-4 py-3 bg-primary font-bold"
                  onClick={ClickNewOrder}
                >
                  <AddIcon />
                  <p className="ml-2">new order</p>
                </Button>
                <Button
                  variant="contained"
                  className="px-4 py-3 bg-primary font-bold"
                  onClick={ClickEditAccount}
                >
                  <EditIcon />
                  <p className="ml-2">edit account</p>
                </Button>
              </div>
            </div>
          )
        }

        <OrderListTable search={search} updateFunction={ClickUpdateOrder} />
        <CancelConfirmationModal
          open={isCancelConfirmationModalOpen}
          title="To place a new order, your paymentcard should be verified. Would you like to proceed to the Payment Card page?"
          onApprove={() => GoToPaymentCardPage()}
          onClose={() => setIsCancelConfirmationModalOpen(false)}
        />
      </main>
    </div>
  );
}
